import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as toastr from 'toastr';

import pickListActions from './pickListActions';

import { Page, PageContent, PageHeader } from '../../components/common';
import PickListItemForm from './PickListItemForm';

interface Props {
	actions: any;
	history: any;
	match: any;
	pickListItem: PickListItem;
}
interface State {
	isLoading: boolean;
}
class PickListItemPage extends React.Component<Props, State> {
	state = {
		isLoading: false
	};

	componentDidMount() {
		this.props.actions.getPickListItem(this.props.match.params.pickListItemId);
	}

	onChange = (e: any) => {
		const pickListItem = {
			...this.props.pickListItem,
			[e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
		};

		this.props.actions.setPickListItem(pickListItem);
	}

	onDelete = (pickListItemId: string) => {
		toastr.error('NOT IMPLEMENTED');
	}

	onSave = () => {
		this.setState({ isLoading: true });
		this.props.actions.savePickListItem(this.props.pickListItem)
			.then(() => this.setState({ isLoading: false }))
			.then(() => {
				toastr.success('Pick List Item saved');
				this.props.history.push(`admin/pick-lists/${this.props.match.params.pickListItemId}`);
			});
	}

	render() {
		const title = this.props.match.pickListItemId !== 'new'
			? `Edit ${this.props.pickListItem.description}`
			: 'Add new pick list item';
		return (
			<Page title={title}>
				<PageContent>
					<PageHeader title={title} />
					<PickListItemForm
						pickListItem={this.props.pickListItem}
						onChange={this.onChange}
						onDelete={this.onDelete}
						onSave={this.onSave}
						isLoading={this.state.isLoading}
					/>
				</PageContent>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		pickListItem: state.pickList.item
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...pickListActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(PickListItemPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/PickList/PickListItemPage.tsx